import classnames from "classnames";

import WithLink from "features/common/components/WithLink";
import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { addLinkMeta, modalLink } from "features/common/routing/utils";

import styles from "./FeedbackLink.module.scss";

type FeedbackComponentProps = {
  textColour?: string;
  text?: string;
  icon?: string;
  onClick?: () => void;
};

// Basic presentational component
export function FeedbackComponent({
  textColour,
  onClick,
  text = "Feedback?",
  icon = "bullhorn"
}: FeedbackComponentProps) {
  return (
    <div
      className={styles.wrapper}
      style={{
        color: textColour
      }}
      onClick={onClick}
    >
      <i className={classnames(`fa fa-${icon}`, styles.icon)} />
      <span className={styles.text}>{text}</span>
    </div>
  );
}

const FeedbackComponentWithLink = WithLink(FeedbackComponent);

type FeedbackLinkProps = FeedbackComponentProps & {
  to: string;
  internal?: boolean;
  meta?: Record<string, any>;
};

// Component that transforms a string url into the link object required
const FeedbackLink = ({ to, internal, meta, ...props }: FeedbackLinkProps) => {
  let link = modalLink(to);

  if (internal) {
    link = makeInternalRedirectState(link);
  }

  if (meta) {
    link = addLinkMeta(link as any, meta);
  }

  return <FeedbackComponentWithLink to={link as any} {...props} />;
};

export default FeedbackLink;
